// // import React, { useState, useEffect, useCallback } from "react";
// // import { Box, Button, Typography } from "@mui/material";
// // import { useNavigate } from "react-router-dom";
// // import { ExamHeader } from "./ExamHeader";
// // import { QuestionTabs } from "./QuestionTabs";
// // import { QuestionPopup } from "./QuestionPopup";
// // import { SubmitSuccessPopup } from "./SubmitSuccessPopup";
// // import { useRecording } from "./useRecording";
// // import { ExamName } from "./ExamName";
// // import "./VivaExam.css";
// // import axios from "axios";
// // import { useParams } from "react-router-dom";
// // import Config from "../config";
// // import { useRef, useMemo } from "react";
// // import SubmitVivaDialog from "./SubmitVivaDialog";
// // import { useVivaSecurity } from "./vivaSecurity";
// // import { VivaViolationDialog } from "./VivaViolationDialog";



// // const User_URL = Config.user_url;
// // export const RightCard = ({
// //   ee_id,
// //   currentQuestion,
// //   setCurrentQuestion,
// //   questionStatus,
// //   setQuestionStatus,
// //   isRecording,
// //   setIsRecording,
// //   stream,
// //   setStream,
// //   audioStream,
// //   setAudioStream,
  

// // }) => {
// //   const navigate = useNavigate();

// //   const [recordingStartTime, setRecordingStartTime] = useState(null);
// //   const [recordingDuration, setRecordingDuration] = useState(0);
// //   const [showSuccess, setShowSuccess] = useState(false);
// //   const [questions, setQuestions] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [timeLeft, setTimeLeft] = useState(0); // total exam time left (in seconds)
// //   const [isTimeUp, setIsTimeUp] = useState(false);
// //   const wsRef = useRef(null);
// //   const timerRef = useRef(null);
// //   const vivaId = useMemo(() => localStorage.getItem("vivaExamSessionId") || "", []);
// //   const [duration, setDuration] = useState(0);
// //   const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
// //   const [examCompleted, setExamCompleted] = useState(false);
// //   const qId = questions[currentQuestion]?.Id;
// //   const [submitDialog, setSubmitDialog] = useState({
// //     open: false,
// //     isAuto: false,
// //     autoReason: null,
// //   });
// //   //   const [violationPopup, setViolationPopup] = useState(null);
// //   // const [violationCount, setViolationCount] = useState(0);
// //   const [violationOpen, setViolationOpen] = useState(false);
// //   const [violationMessage, setViolationMessage] = useState("");
// //   const [violationCount, setViolationCount] = useState(0);
// //   const MAX_VIOLATIONS = 3;
// //   // const [forceSubmit, setForceSubmit] = useState(false);
// //   const [isSubmitting, setIsSubmitting] = useState(false);
// //   const [showPopup, setShowPopup] = useState(false);

// //   const [questionTranscript, setQuestionTranscript] = useState("");
// //   const [showSavingPopup, setShowSavingPopup] = useState(false);
// //     const videoRecorderRef = useRef(null);
// //   const videoChunksRef = useRef([]);



// //   const allQuestionsAnswered = Object.values(questionStatus).every(
// //     (status) => status === "answered"
// //   );

// //   const protocol = window.location.protocol === "https:" ? "wss" : "ws";
// //   const host = window.location.host;


// //   const { startRecording, stopRecording, submitRecordingForQuestion } = useRecording({
// //     setAudioStream,
// //     setStream,
// //     setIsRecording,
// //     setRecordingStartTime,
// //     setRecordingDuration,
// //     currentQuestion,
// //     setQuestionStatus,
// //     currentVivaQuestionId: questions[currentQuestion]?.Id,
// //     ee_id
// //   });



// //   // const { localViolation } = useVivaSecurity(
// //   //   ee_id,
// //   //   handleForceSubmit,
// //   //   setViolationPopup,
// //   //   setViolationCount
// //   // );

// //   const handleForceSubmit = (reason = "malpractice") => {
// //     // 🔒 FORCE
// //     setSubmitDialog({
// //       open: true,
// //       isAuto: true,
// //       autoReason: reason,
// //     });
// //   };

// //   const { triggerViolation } = useVivaSecurity(
// //     ee_id,
// //     handleForceSubmit,
// //     setViolationOpen,
// //     setViolationMessage,
// //     setViolationCount,
// //     // setShowSubmitDialog
// //   );








// //   useEffect(() => {
// //     if (!ee_id) return;

// //     const fetchDuration = async () => {
// //       try {
// //         const response = await axios.get(`/viva/get-duration/${ee_id}/`);
// //         setDuration(response.data.duration);
// //         console.log(response.data.duration, "kkkkkkkkkkkkkkkkkkk");
// //       } catch (error) {
// //         console.error("Error fetching duration:", error);
// //       }
// //     };

// //     fetchDuration();
// //   }, [ee_id]);



// //   useEffect(() => {
// //     let stored = null;

// //     try {
// //       stored = JSON.parse(localStorage.getItem("vivaQIds"));
// //     } catch (e) {
// //       stored = null;
// //     }

// //     if (Array.isArray(stored) && stored.length > 0) {
// //       setQuestions(stored);

// //       const statusDict = {};
// //       stored.forEach(q => {
// //         statusDict[q.Id] = "not-started";
// //       });
// //       setQuestionStatus(statusDict);
// //     } else {
// //       setQuestions([]); // ALWAYS ensure array
// //       setQuestionStatus({});
// //       console.warn("Invalid vivaQIds in localStorage");
// //     }

// //     setLoading(false);
// //   }, []);


// //   // const handleAnswerClick = async () => {
// //   //   const qId = questions[currentQuestion]?.Id;

// //   //   // 🚫 BLOCK answered questions
// //   //   if (qId && questionStatus[qId] === "answered") {
// //   //     alert("You have already answered this question.");
// //   //     return;
// //   //   }
// //   //   try {

// //   //     console.log("vivaQIds:", questions);
// //   //     const QuestionId = questions[currentQuestion]?.Id;
// //   //     console.log("QuestionId:", QuestionId, "Current Question:", currentQuestion);
// //   //     if (!QuestionId) {
// //   //       alert("Question ID not found in local storage!");
// //   //       return;
// //   //     }

// //   //     const response = await axios.get(
// //   //       `/employee/get-question/?question_id=${QuestionId}`
// //   //     );
// //   //     console.log("API response:", response.data);

// //   //     if (
// //   //       response.status === 200 &&
// //   //       response.data &&
// //   //       Array.isArray(response.data.questions) &&
// //   //       response.data.questions.length > 0
// //   //     ) {
// //   //       const fetchedQuestion = response.data.questions[0];
// //   //       setQuestions((prev = []) => {
// //   //         const updated = Array.isArray(prev) ? [...prev] : [];
// //   //         updated[currentQuestion] = {
// //   //           Id: QuestionId,
// //   //           ...(prev?.[currentQuestion] || {}),
// //   //           ...fetchedQuestion,
// //   //         };
// //   //         return updated;
// //   //       });

// //   //       console.log("Updated questions:", questions);
// //   //       setShowPopup(true);
// //   //       await startRecording();
// //   //     } else {
// //   //       alert("No question data received from server.");
// //   //     }
// //   //   } catch (error) {
// //   //     console.error("Error fetching question:", error);
// //   //     alert("Unable to fetch question. Please try again.");
// //   //   }
// //   // };



// //   const handleAnswerClick = async () => {
// //     try {

// //       setQuestionTranscript("");
// //       const storedQuestions =
// //         JSON.parse(localStorage.getItem("vivaQIds")) || [];

// //       const QuestionId = storedQuestions[currentQuestion]?.Id;

// //       if (!QuestionId) {
// //         alert("Question ID not found!");
// //         return;
// //       }

// //       if (questionStatus[QuestionId] === "answered") {
// //         alert("You have already answered this question.");
// //         return;
// //       }

// //       const response = await axios.get(
// //         `/employee/get-question/?question_id=${QuestionId}`
// //       );

// //       if (
// //         response.status === 200 &&
// //         Array.isArray(response.data.questions) &&
// //         response.data.questions.length > 0
// //       ) {
// //         const fetchedQuestion = response.data.questions[0];

// //         setQuestions((prev = []) => {
// //           const updated = [...prev];

// //           updated[currentQuestion] = {
// //             Id: QuestionId,
// //             ...(prev?.[currentQuestion] || {}),
// //             ...fetchedQuestion,
// //           };

// //           return updated;
// //         });

// //         setShowPopup(true);
// //         await startRecording();
// //       } else {
// //         alert("No question data received from server.");
// //       }
// //     } catch (error) {
// //       console.error("Error fetching question:", error);
// //       alert("Unable to fetch question. Please try again.");
// //     }
// //   };
// //   useEffect(() => {
// //     if (!duration) return;
// //     console.log("Updated duration:", duration);
// //     const stored = duration * 60;
// //     console.log("Stored durationSeconds:", stored);
// //     if (stored) setTimeLeft(parseInt(stored, 10));
// //   }, [duration]);

// //   useEffect(() => {
// //     if (!vivaId) return;
// //     const ws = new WebSocket(`ws://localhost:8000/ws/viva_portal/${ee_id}/`);
// //     // const ws = new WebSocket(`${protocol}://${host}/ws/viva_portal/${ee_id}/`);
// //     wsRef.current = ws;
// //     ws.onmessage = (e) => {
// //       const data = JSON.parse(e.data);

// //       // --- INIT FROM BACKEND ---
// //       if (data.action === "init") {

// //         if (data.time_left !== undefined) {
// //           setTimeLeft(data.time_left);
// //         }

// //         if (data.attempted_questions !== undefined) {
// //           updateAttemptedStatus(data.attempted_questions);
// //         }

// //         // receive current question logic
// //         if (data.current_question) {
// //           const { currentQuestionIndex, currentQuestion, isCompleted } = data.current_question;

// //           setCurrentQuestionIndex(currentQuestionIndex);
// //           setCurrentQuestion(currentQuestion);
// //           setExamCompleted(isCompleted);
// //         }
// //       }

// //       // --- TIMER UPDATE FROM BACKEND ---
// //       if (data.action === "time_update") {

// //         if (data.time_left !== undefined) {
// //           setTimeLeft(data.time_left);
// //         }

// //         if (data.attempted_questions !== undefined) {
// //           updateAttemptedStatus(data.attempted_questions);
// //         }
// //       }
// //     };


// //     ws.onclose = () => console.log("⛔ Timer WebSocket closed");

// //     return () => ws.close();
// //   }, [vivaId]);

// //   useEffect(() => {
// //     if (timeLeft <= 0 || !wsRef.current) return;

// //     const interval = setInterval(() => {
// //       const next = Math.max(timeLeft - 1, 0);
// //       setTimeLeft(next);

// //       if (wsRef.current?.readyState === WebSocket.OPEN) {
// //         wsRef.current.send(JSON.stringify({ action: "time_update", time_left: next }));
// //       }

// //       if (next <= 0) handleTimeUp();
// //     }, 1000);

// //     timerRef.current = interval;
// //     return () => clearInterval(timerRef.current);
// //   }, [timeLeft]);

// //   useEffect(() => {
// //     const attempted = JSON.parse(localStorage.getItem("attemptedQuestions")) || [];
// //     updateAttemptedStatus(attempted);
// //   }, []);

// //   useEffect(() => {
// //     if (showPopup || showSavingPopup || showSuccess || submitDialog.open || violationOpen) {
// //       document.body.classList.add("modal-open");
// //     } else {
// //       document.body.classList.remove("modal-open");
// //     }
// //     return () => document.body.classList.remove("modal-open");
// //   }, [showPopup, showSavingPopup, showSuccess, submitDialog.open, violationOpen]);

// //   const updateAttemptedStatus = (attemptedIds = []) => {
// //     if (!Array.isArray(attemptedIds) || attemptedIds.length === 0) return;

// //     setQuestionStatus((prev = {}) => {
// //       const updated = { ...prev };

// //       attemptedIds.forEach((qid) => {
// //         updated[qid] = "answered";
// //       });

// //       return updated;
// //     });
// //   };







// //   const handleSave = async (transcript = questionTranscript) => {
// //     const { audioBlob,videoBlob } = await stopRecording();

// //     const user_id = localStorage.getItem("username") || "1";
// //     const vivaQuestionId = questions[currentQuestion].Id
// //     const QuestionDescription = questions[currentQuestion]?.QuestionDescription
// //     console.log(user_id, vivaQuestionId, QuestionDescription, "Here")
// //     const result = await submitRecordingForQuestion(audioBlob, videoBlob,user_id, vivaQuestionId, QuestionDescription, ee_id,transcript);

// //     if (result.success) {
// //       setQuestionStatus((prev = {}) => ({
// //         ...(prev || {}),
// //         [questions[currentQuestion].Id]: "answered"
// //       }));


// //       setShowPopup(false);

// //       if (currentQuestion < questions.length - 1) {
// //         setCurrentQuestion(currentQuestion + 1);
// //       }
// //     } else {
// //       alert("Failed to save this answer: " + result.error);
// //     }
// //   };

// //   const handleTimeUp = async () => {
// //     setIsTimeUp(true);
// //     console.log("⏰ Time’s up! Auto-saving and submitting...");

// //     // await handleSave(); // auto-save current question
// //     await handleSave(questionTranscript);

// //     // Open the submit dialog with timeout reason; the dialog will auto‑submit after 1500ms
// //     setSubmitDialog({
// //       open: true,
// //       isAuto: true,
// //       autoReason: "timeout",
// //     });
// //   };

// //   // const handleFinalSubmit = async () => {

// //   //   try {

// //   //     const response = await fetch(`/viva/submit_viva_exam/`, {
// //   //       method: "POST",
// //   //       headers: {
// //   //         "Content-Type": "application/json",
// //   //       },
// //   //     });

// //   //     const data = await response.json();

// //   //     if (response.ok) {
// //   //       console.log("✅ Report generated successfully:", data);
// //   //       // alert("Report generated successfully!");
// //   //       setShowSuccess(true);
// //   //     } else {
// //   //       console.error("❌ Error generating report:", data.error);
// //   //       alert("Failed to generate report: " + data.error);
// //   //     }
// //   //   } catch (error) {
// //   //     console.error("⚠️ Network or server error:", error);
// //   //     alert("Something went wrong: " + error.message);
// //   //   }
// //   // };

// //   const handleFinalSubmit = useCallback(async () => {
// //     if (isSubmitting) return;

// //     try {
// //       setIsSubmitting(true);

// //       const response = await fetch(`/viva/submit_viva_exam/`, {
// //         method: "POST",
// //         headers: { "Content-Type": "application/json" },
// //       });

// //       const data = await response.json();

// //       if (response.ok) {
// //         console.log("✅ Report generated successfully:", data);
// //         // Close any open dialog / popup
// //         setSubmitDialog({ open: false, isAuto: false, autoReason: null });
// //         setShowPopup(false);
// //         // Show success popup – it will handle fullscreen exit & navigation
// //         setShowSuccess(true);
// //       } else {
// //         throw new Error(data.error || "Submission failed");
// //       }
// //     } catch (error) {
// //       console.error("❌ Submit error:", error);
// //       alert("Submission failed. Please try again.");
// //       // Re‑enable only on failure
// //       setIsSubmitting(false);
// //     }
// //   }, [isSubmitting]);



// //   const escTriggeredRef = useRef(false);
// //   const pendingViolationRef = useRef(null);



// //   // ✅ When popup

// //   useEffect(() => {
// //     const onFullscreenChange = () => {
// //       if (!document.fullscreenElement) {
// //         if (escTriggeredRef.current) {
// //           escTriggeredRef.current = false;
// //           return;
// //         }

// //         triggerViolation(
// //           "EXIT_FULLSCREEN",
// //           "You exited fullscreen. Assessment must remain in fullscreen."
// //         );
// //       }
// //     };

// //     const onVisibilityChange = () => {
// //       if (document.hidden) {
// //         pendingViolationRef.current = {
// //           type: "TAB_SWITCH",
// //           message: "Switching tabs is not allowed during Viva."
// //         };

// //         triggerViolation(
// //           "TAB_SWITCH",
// //           "Switching tabs is not allowed during Viva."
// //         );
// //       } else {
// //         if (pendingViolationRef.current) {
// //           setViolationMessage(pendingViolationRef.current.message);
// //           setViolationOpen(true);
// //           pendingViolationRef.current = null;
// //         }
// //       }
// //     };

// //     const onKeyDown = (e) => {
// //       if (e.key === "Escape") {
// //         e.preventDefault();
// //         escTriggeredRef.current = true;

// //         triggerViolation("ESCAPE_KEY", "ESC key is not allowed during Viva.");
// //         return;
// //       }

// //       const isRefresh =
// //         (e.ctrlKey && e.key.toLowerCase() === "r") ||
// //         (e.metaKey && e.key.toLowerCase() === "r") ||
// //         e.key === "F5";

// //       if (isRefresh) {
// //         e.preventDefault();
// //         triggerViolation(
// //           "PAGE_REFRESH",
// //           "Page refresh is not allowed during Viva."
// //         );
// //       }
// //     };

// //     const blockBackNavigation = () => {
// //       window.history.pushState(null, "", window.location.href);
// //     };

// //     const onPopState = () => {
// //       blockBackNavigation();
// //       triggerViolation(
// //         "BACK_NAVIGATION",
// //         "Back navigation is not allowed during Viva."
// //       );
// //     };

// //     blockBackNavigation();

// //     document.addEventListener("fullscreenchange", onFullscreenChange);
// //     document.addEventListener("visibilitychange", onVisibilityChange);
// //     window.addEventListener("keydown", onKeyDown);
// //     window.addEventListener("popstate", onPopState);

// //     return () => {
// //       document.removeEventListener("fullscreenchange", onFullscreenChange);
// //       document.removeEventListener("visibilitychange", onVisibilityChange);
// //       window.removeEventListener("keydown", onKeyDown);
// //       window.removeEventListener("popstate", onPopState);
// //     };
// //   }, [triggerViolation]);

// //   //  closes (either manually or auto)

// //   const handlePopupClose = () => {
// //     if (document.fullscreenElement) {
// //       document.exitFullscreen().catch(() => { });
// //     }
// //     setShowSuccess(false);
// //     navigate("/users/dashboard", {
// //       state: { questions, questionStatus },
// //     });
// //   };

// //   useEffect(() => {
// //     if (violationCount >= MAX_VIOLATIONS) {
// //       setShowPopup(false);
// //       setShowSavingPopup(false);
// //     }
// //   }, [violationCount]);

// //   const handleDialogConfirm = useCallback(() => {
// //     setSubmitDialog({ open: false, isAuto: false, autoReason: null });
// //     handleFinalSubmit();
// //   }, [handleFinalSubmit]); // handleFinalSubmit itself may change, but we'll stabilize it too (next step)

// //   // Recording timer
// //   useEffect(() => {
// //     let interval = null;
// //     if (isRecording && recordingStartTime) {
// //       interval = setInterval(() => {
// //         setRecordingDuration(
// //           Math.floor((Date.now() - recordingStartTime) / 1000)
// //         );
// //       }, 1000);
// //     }
// //     return () => interval && clearInterval(interval);
// //   }, [isRecording, recordingStartTime]);

// //   // Stop streams on unmount
// //   useEffect(() => {
// //     return () => {
// //       if (audioStream) audioStream.getTracks().forEach((t) => t.stop());
// //       if (stream) stream.getTracks().forEach((t) => t.stop());
// //     };
// //   }, [audioStream, stream]);




// //   return (
// //     <Box
// //       className="exam-card"
// //       sx={{
// //         position: "fixed",

// //         // 🔥 OVERSCAN FIX (critical)
// //         top: "-2px",
// //         left: "-2px",
// //         width: "calc(100vw + 4px)",
// //         height: "calc(100vh + 4px)",

// //         overflow: "hidden",
// //         backgroundColor: "#edf2f7",
// //         padding: 2,
// //         boxSizing: "border-box",
// //         transform: "translateZ(0)",
// //         backfaceVisibility: "hidden",
// //       }}
// //     >

// //       <ExamName />
// //       <ExamHeader
// //         currentQuestion={currentQuestion}
// //         totalQuestions={questions.length}
// //         isRecording={isRecording}
// //         questionStatus={questionStatus}
// //         timeLeft={timeLeft}
// //       />

// //       <QuestionTabs
// //         currentQuestion={currentQuestion}
// //         setCurrentQuestion={setCurrentQuestion}
// //         questionStatus={questionStatus}
// //         questions={questions}
// //       />

// //       {!showPopup && !showSuccess && (
// //         <Box
// //           sx={{
// //             border: "1px solid var(--border, #ccc)",
// //             textAlign: "center",
// //             mt: 2,
// //             flexGrow: 1,
// //             display: "flex",
// //             flexDirection: "column",
// //             justifyContent: "flex-start",
// //             pt: 4,
// //             pb: 6,
// //           }}
// //         >
// //           <Box
// //             className="question-text"
// //             sx={{ fontSize: 20, fontWeight: 600, mb: 4 }}
// //           >
// //             {questionStatus[qId] === "not-started" && (
// //               <>
// //                 <Box sx={{ pt: 5 }}>{"Are you ready to answer this question?"}</Box>
// //                 <Box sx={{ fontSize: 40, mb: 2, color: "var(--brand)" }}>
// //                   <i className="fa fa-question-circle"></i>
// //                 </Box>
// //               </>
// //             )}
// //             {questionStatus[qId] === "recording" &&
// //               questions[currentQuestion]?.QuestionDescription}
// //             {questionStatus[qId] === "answered" &&
// //               "✅ Successfully saved your response"}
// //           </Box>

// //           {questionStatus[qId] !== "answered" && (
// //             <Button className="answer-button" onClick={handleAnswerClick}>
// //               Answer
// //             </Button>
// //           )}
// //         </Box>
// //       )}

// //       {showPopup && (
// //         <div
// //           style={{
// //             position: "fixed",
// //             inset: 0,
// //             width: "100vw",
// //             height: "100vh",
// //             background: "rgba(0,0,0,0.6)",
// //             zIndex: 99999,
// //             display: "flex",
// //             alignItems: "center",
// //             justifyContent: "center",
// //           }}
// //         >
// //           <QuestionPopup
// //             question={questions[currentQuestion]}
// //             currentQuestion={currentQuestion}
// //             isRecording={isRecording}
// //             stream={stream}
// //             audioStream={audioStream}
// //             startRecording={startRecording}
// //             transcript={questionTranscript}
// //             setTranscript={setQuestionTranscript}
// //             handleSave={handleSave}
// //             onClose={() => setShowPopup(false)}
// //             onSaveStart={() => setShowSavingPopup(true)}
// //             onSaveEnd={() => setShowSavingPopup(false)}
// //           />
// //         </div>
// //       )}

// //       {showSavingPopup && (
// //         <Box
// //           sx={{
// //             position: "fixed",
// //             top: 0,
// //             left: 0,
// //             width: "100vw",
// //             height: "100vh",
// //             background: "rgba(0,0,0,0.4)",
// //             display: "flex",
// //             alignItems: "center",
// //             justifyContent: "center",
// //             zIndex: 9999,
// //           }}
// //         >
// //           <Box
// //             sx={{
// //               background: "#fff",
// //               padding: 4,
// //               borderRadius: 2,
// //               minWidth: 280,
// //               display: "flex",
// //               flexDirection: "column",
// //               alignItems: "center",
// //               gap: 2,
// //             }}
// //           >
// //             <Box
// //               sx={{
// //                 width: 40,
// //                 height: 40,
// //                 border: "4px solid #e2e8f0",
// //                 borderTop: "4px solid #f79033",
// //                 borderRadius: "50%",
// //                 animation: "spin 1s linear infinite",
// //               }}
// //             />
// //             <Typography sx={{ fontSize: 15, fontWeight: 600 }}>
// //               Please wait
// //             </Typography>
// //             <Typography sx={{ fontSize: 13, color: "#666" }}>
// //               Saving your response…
// //             </Typography>
// //           </Box>
// //         </Box>
// //       )}


// //       {/* {violationOpen && (
// //   <VivaViolationDialog
// //     message={violationMessage}
// //     count={violationCount}
// //     max={3}
// //     onContinue={() => {
// //       setViolationOpen(false);
// //       document.documentElement.requestFullscreen().catch(() => {});
// //     }}
// //   />
// // )} */}

// //       {violationOpen && violationCount < MAX_VIOLATIONS && (
// //         <VivaViolationDialog
// //           message={violationMessage}
// //           count={violationCount}
// //           max={3}
// //           onContinue={() => {
// //             setViolationOpen(false);
// //             document.documentElement.requestFullscreen().catch(() => { });
// //           }}
// //         />
// //       )}




// //       {/* Submit Confirmation Dialog */}
// //       <SubmitVivaDialog
// //         open={submitDialog.open}
// //         isAuto={submitDialog.isAuto}
// //         autoReason={submitDialog.autoReason}
// //         onClose={() => setSubmitDialog({ open: false, isAuto: false, autoReason: null })}
// //         isSubmitting={isSubmitting}
// //         onConfirm={handleDialogConfirm}
// //         questions={questions}
// //         questionStatus={questionStatus}
// //       />

// //       {showSuccess && (
// //         <div
// //           style={{
// //             position: "fixed",
// //             inset: 0,
// //             width: "100vw",
// //             height: "100vh",
// //             background: "rgba(0,0,0,0.6)",
// //             zIndex: 99999,
// //             display: "flex",
// //             alignItems: "center",
// //             justifyContent: "center",
// //           }}
// //         >
// //           <SubmitSuccessPopup onClose={handlePopupClose} autoClose={handlePopupClose} />
// //         </div>
// //       )}

// //       {/* {!showSuccess && (
// //         <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
// //           <Button className="submit-final-button" onClick={handleFinalSubmit}>
// //             Submit
// //           </Button>
// //         </Box>
// //       )} */}
// //       {!showSuccess && (
// //         <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
// //           <Button
// //             className="submit-final-button"
// //             variant="contained"
// //             color="error"
// //             size="large"
// //             // onClick={() => setShowSubmitDialog(true)}
// //             onClick={() => {
// //               setSubmitDialog({
// //                 open: true,
// //                 isAuto: false,
// //                 autoReason: null,
// //               });
// //             }}
// //           >
// //             Submit
// //           </Button>
// //         </Box>
// //       )}
// //     </Box>
// //   );
// // };



// import React, { useState, useEffect, useCallback } from "react";
// import { Box, Button, Typography } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import { ExamHeader } from "./ExamHeader";
// import { QuestionTabs } from "./QuestionTabs";
// import { QuestionPopup } from "./QuestionPopup";
// import { SubmitSuccessPopup } from "./SubmitSuccessPopup";
// import { useRecording } from "./useRecording";
// import { ExamName } from "./ExamName";
// import "./VivaExam.css";
// import axios from "axios";
// import { useParams } from "react-router-dom";
// import Config from "../config";
// import { useRef, useMemo } from "react";
// import SubmitVivaDialog from "./SubmitVivaDialog";
// import { useVivaSecurity } from "./vivaSecurity";
// import { VivaViolationDialog } from "./VivaViolationDialog";



// const User_URL = Config.user_url;
// export const RightCard = ({
//   ee_id,
//   currentQuestion,
//   setCurrentQuestion,
//   questionStatus,
//   setQuestionStatus,
//   isRecording,
//   setIsRecording,
//   stream,
//   setStream,
//   audioStream,
//   setAudioStream,
  

// }) => {
//   const navigate = useNavigate();

//   const [recordingStartTime, setRecordingStartTime] = useState(null);
//   const [recordingDuration, setRecordingDuration] = useState(0);
//   const [showSuccess, setShowSuccess] = useState(false);
//   const [questions, setQuestions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [timeLeft, setTimeLeft] = useState(0); // total exam time left (in seconds)
//   const [timerReady, setTimerReady] = useState(false);
//   const [isTimeUp, setIsTimeUp] = useState(false);
//   const wsRef = useRef(null);
//   const timerRef = useRef(null);
//   const vivaId = useMemo(() => localStorage.getItem("vivaExamSessionId") || "", []);
//   const [duration, setDuration] = useState(0);
//   const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
//   const [examCompleted, setExamCompleted] = useState(false);
//   const qId = questions[currentQuestion]?.Id;
//   const [submitDialog, setSubmitDialog] = useState({
//     open: false,
//     isAuto: false,
//     autoReason: null,
//   });
//   //   const [violationPopup, setViolationPopup] = useState(null);
//   // const [violationCount, setViolationCount] = useState(0);
//   const [violationOpen, setViolationOpen] = useState(false);
//   const [violationMessage, setViolationMessage] = useState("");
//   const [violationCount, setViolationCount] = useState(0);
//   const MAX_VIOLATIONS = 3;
//   // const [forceSubmit, setForceSubmit] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [showPopup, setShowPopup] = useState(false);

//   const [questionTranscript, setQuestionTranscript] = useState("");
//   const [showSavingPopup, setShowSavingPopup] = useState(false);
//     const videoRecorderRef = useRef(null);
//   const videoChunksRef = useRef([]);
//     const examFinalizedRef = useRef(false);
//     const timeUpTriggeredRef = useRef(false);
//     const timerReadyRef = useRef(false);



//   const allQuestionsAnswered = Object.values(questionStatus).every(
//     (status) => status === "answered"
//   );

//   const protocol = window.location.protocol === "https:" ? "wss" : "ws";
//   const host = window.location.host;


//   const { startRecording, stopRecording, submitRecordingForQuestion, isSubmittingRef: questionSubmitRef } = useRecording({
//     setAudioStream,
//     setStream,
//     setIsRecording,
//     setRecordingStartTime,
//     setRecordingDuration,
//     currentQuestion,
//     setQuestionStatus,
//     currentVivaQuestionId: questions[currentQuestion]?.Id,
//     ee_id
//   });



//   // const { localViolation } = useVivaSecurity(
//   //   ee_id,
//   //   handleForceSubmit,
//   //   setViolationPopup,
//   //   setViolationCount
//   // );

//   const handleForceSubmit = (reason = "malpractice") => {
//     // 🔒 FORCE
//     setSubmitDialog({
//       open: true,
//       isAuto: true,
//       autoReason: reason,
//     });
//   };

//   const { triggerViolation } = useVivaSecurity(
//     ee_id,
//     handleForceSubmit,
//     setViolationOpen,
//     setViolationMessage,
//     setViolationCount,
//     // setShowSubmitDialog
//   );








//   useEffect(() => {
//     if (!ee_id) return;

//     const fetchDuration = async () => {
//       try {
//         const response = await axios.get(`/viva/get-duration/${ee_id}/`);
//         setDuration(response.data.duration);
//         console.log(response.data.duration, "kkkkkkkkkkkkkkkkkkk");
//       } catch (error) {
//         console.error("Error fetching duration:", error);
//       }
//     };

//     fetchDuration();
//   }, [ee_id]);



//   useEffect(() => {
//     let stored = null;

//     try {
//       stored = JSON.parse(localStorage.getItem("vivaQIds"));
//     } catch (e) {
//       stored = null;
//     }

//     if (Array.isArray(stored) && stored.length > 0) {
//       setQuestions(stored);

//       const statusDict = {};
//       stored.forEach(q => {
//         statusDict[q.Id] = "not-started";
//       });
//       setQuestionStatus(statusDict);
//     } else {
//       setQuestions([]); // ALWAYS ensure array
//       setQuestionStatus({});
//       console.warn("Invalid vivaQIds in localStorage");
//     }

//     setLoading(false);
//   }, []);


//   // const handleAnswerClick = async () => {
//   //   const qId = questions[currentQuestion]?.Id;

//   //   // 🚫 BLOCK answered questions
//   //   if (qId && questionStatus[qId] === "answered") {
//   //     alert("You have already answered this question.");
//   //     return;
//   //   }
//   //   try {

//   //     console.log("vivaQIds:", questions);
//   //     const QuestionId = questions[currentQuestion]?.Id;
//   //     console.log("QuestionId:", QuestionId, "Current Question:", currentQuestion);
//   //     if (!QuestionId) {
//   //       alert("Question ID not found in local storage!");
//   //       return;
//   //     }

//   //     const response = await axios.get(
//   //       `/employee/get-question/?question_id=${QuestionId}`
//   //     );
//   //     console.log("API response:", response.data);

//   //     if (
//   //       response.status === 200 &&
//   //       response.data &&
//   //       Array.isArray(response.data.questions) &&
//   //       response.data.questions.length > 0
//   //     ) {
//   //       const fetchedQuestion = response.data.questions[0];
//   //       setQuestions((prev = []) => {
//   //         const updated = Array.isArray(prev) ? [...prev] : [];
//   //         updated[currentQuestion] = {
//   //           Id: QuestionId,
//   //           ...(prev?.[currentQuestion] || {}),
//   //           ...fetchedQuestion,
//   //         };
//   //         return updated;
//   //       });

//   //       console.log("Updated questions:", questions);
//   //       setShowPopup(true);
//   //       await startRecording();
//   //     } else {
//   //       alert("No question data received from server.");
//   //     }
//   //   } catch (error) {
//   //     console.error("Error fetching question:", error);
//   //     alert("Unable to fetch question. Please try again.");
//   //   }
//   // };



//   const handleAnswerClick = async () => {
//         if (examFinalizedRef.current) return;

//     try {

//       setQuestionTranscript("");
//       const storedQuestions =
//         JSON.parse(localStorage.getItem("vivaQIds")) || [];

//       const QuestionId = storedQuestions[currentQuestion]?.Id;

//       if (!QuestionId) {
//         alert("Question ID not found!");
//         return;
//       }

//       if (questionStatus[QuestionId] === "answered") {
//         alert("You have already answered this question.");
//         return;
//       }

//       const response = await axios.get(
//         `/employee/get-question/?question_id=${QuestionId}`
//       );

//       if (
//         response.status === 200 &&
//         Array.isArray(response.data.questions) &&
//         response.data.questions.length > 0
//       ) {
//         const fetchedQuestion = response.data.questions[0];

//         setQuestions((prev = []) => {
//           const updated = [...prev];

//           updated[currentQuestion] = {
//             Id: QuestionId,
//             ...(prev?.[currentQuestion] || {}),
//             ...fetchedQuestion,
//           };

//           return updated;
//         });

//         setShowPopup(true);
//         await startRecording();
//       } else {
//         alert("No question data received from server.");
//       }
//     } catch (error) {
//       console.error("Error fetching question:", error);
//       alert("Unable to fetch question. Please try again.");
//     }
//   };
//   useEffect(() => {
//     if (!duration || timerReadyRef.current) return;
//     console.log("Updated duration:", duration);
//     const stored = Number(duration) * 60;
//     console.log("Stored durationSeconds:", stored);
//     if (Number.isFinite(stored) && stored > 0) {
//       timerReadyRef.current = true;
//       setTimerReady(true);
//       setTimeLeft(parseInt(stored, 10));
//     }
//   }, [duration]);

//   // useEffect(() => {
//   //   if (!vivaId) return;
//   //   const ws = new WebSocket(`ws://localhost:8000/ws/viva_portal/${ee_id}/`);
//   //   // const ws = new WebSocket(`${protocol}://${host}/ws/viva_portal/${ee_id}/`);
//   //   wsRef.current = ws;
//   //   ws.onmessage = (e) => {
//   //     const data = JSON.parse(e.data);

//   //     // --- INIT FROM BACKEND ---
//   //     if (data.action === "init") {

//   //       if (data.time_left !== undefined) {
//   //         setTimeLeft(data.time_left);
//   //       }

//   //       if (data.attempted_questions !== undefined) {
//   //         updateAttemptedStatus(data.attempted_questions);
//   //       }

//   //       // receive current question logic
//   //       if (data.current_question) {
//   //         const { currentQuestionIndex, currentQuestion, isCompleted } = data.current_question;

//   //         setCurrentQuestionIndex(currentQuestionIndex);
//   //         setCurrentQuestion(currentQuestion);
//   //         setExamCompleted(isCompleted);
//   //       }
//   //     }

//   //     // --- TIMER UPDATE FROM BACKEND ---
//   //     if (data.action === "time_update") {

//   //       if (data.time_left !== undefined) {
//   //         setTimeLeft(data.time_left);
//   //       }

//   //       if (data.attempted_questions !== undefined) {
//   //         updateAttemptedStatus(data.attempted_questions);
//   //       }
//   //     }
//   //   };


//   //   ws.onclose = () => console.log("⛔ Timer WebSocket closed");

//   //   return () => ws.close();
//   // }, [vivaId]);


//   useEffect(() => {
//   if (!ee_id) {
//     console.warn("⚠️ No ee_id, skipping WebSocket connection");
//     return;
//   }

//   // Close existing connection if any
//   if (wsRef.current && (wsRef.current.readyState === WebSocket.OPEN || wsRef.current.readyState === WebSocket.CONNECTING)) {
//     wsRef.current.close();
//     wsRef.current = null;
//   }

//   const protocol = window.location.protocol === "https:" ? "wss" : "ws";
//   const host = window.location.host;
//   const ws = new WebSocket(`ws://localhost:8000/ws/viva_portal/${ee_id}/`);
  
//   wsRef.current = ws;
  
//   let isMounted = true;

//   ws.onopen = () => {
//     if (isMounted) {
//       console.log("✅ Viva Portal WebSocket connected");
//       // Send initial sync request
//       ws.send(JSON.stringify({ action: "sync", ee_id }));
//     }
//   };

//   ws.onmessage = (e) => {
//     if (!isMounted) return;
    
//     try {
//       const data = JSON.parse(e.data);

//       // --- INIT FROM BACKEND ---
//       if (data.action === "init") {
//         if (data.time_left !== undefined) {
//           const nextTimeLeft = Number(data.time_left);
//           if (Number.isFinite(nextTimeLeft) && (nextTimeLeft > 0 || timerReadyRef.current)) {
//             timerReadyRef.current = true;
//             setTimerReady(true);
//             setTimeLeft(Math.max(nextTimeLeft, 0));
//           }
//         }

//         if (data.attempted_questions !== undefined) {
//           updateAttemptedStatus(data.attempted_questions);
//         }

//         if (data.current_question) {
//           const { currentQuestionIndex, currentQuestion, isCompleted } = data.current_question;
//           setCurrentQuestionIndex(currentQuestionIndex);
//           setCurrentQuestion(currentQuestion);
//           setExamCompleted(isCompleted);
//         }
//       }

//       // --- TIMER UPDATE FROM BACKEND ---
//       if (data.action === "time_update") {
//         if (data.time_left !== undefined) {
//           const nextTimeLeft = Number(data.time_left);
//           if (Number.isFinite(nextTimeLeft) && (nextTimeLeft > 0 || timerReadyRef.current)) {
//             timerReadyRef.current = true;
//             setTimerReady(true);
//             setTimeLeft(Math.max(nextTimeLeft, 0));
//           }
//         }

//         if (data.attempted_questions !== undefined) {
//           updateAttemptedStatus(data.attempted_questions);
//         }
//       }
//     } catch (error) {
//       console.error("❌ Error parsing WebSocket message:", error);
//     }
//   };

//   ws.onclose = (event) => {
//     if (isMounted) {
//       console.log("⛔ Timer WebSocket closed", event.code, event.reason);
//     }
//   };

//   ws.onerror = (err) => {
//     console.error("❌ WebSocket error:", err);
//   };

//   // Cleanup function
//   return () => {
//     isMounted = false;
//     if (wsRef.current) {
//       if (wsRef.current.readyState === WebSocket.OPEN || wsRef.current.readyState === WebSocket.CONNECTING) {
//         wsRef.current.close();
//       }
//       wsRef.current = null;
//     }
//   };
// }, [ee_id]); // Changed from [vivaId] to [ee_id]


//   useEffect(() => {
//     if (examFinalizedRef.current) return;
//     if (!timerReady) return;

//     if (timeLeft <= 0) {
//       if (questions.length > 0 && !timeUpTriggeredRef.current) {
//         timeUpTriggeredRef.current = true;
//         handleTimeUp();
//       }
//       return;
//     }

//     const interval = setInterval(() => {
//       const next = Math.max(timeLeft - 1, 0);
//       setTimeLeft(next);

//       if (wsRef.current?.readyState === WebSocket.OPEN) {
//         wsRef.current.send(JSON.stringify({ action: "time_update", time_left: next }));
//       }

//       if (next <= 0 && !timeUpTriggeredRef.current) {
//         timeUpTriggeredRef.current = true;
//         handleTimeUp();
//       }
//     }, 1000);

//     timerRef.current = interval;
//     return () => clearInterval(timerRef.current);
//   }, [timeLeft, questions.length, timerReady]);

//   useEffect(() => {
//     const attempted = JSON.parse(localStorage.getItem("attemptedQuestions")) || [];
//     updateAttemptedStatus(attempted);
//   }, []);

//   useEffect(() => {
//     if (showPopup || showSavingPopup || showSuccess || submitDialog.open || violationOpen) {
//       document.body.classList.add("modal-open");
//     } else {
//       document.body.classList.remove("modal-open");
//     }
//     return () => document.body.classList.remove("modal-open");
//   }, [showPopup, showSavingPopup, showSuccess, submitDialog.open, violationOpen]);

//   const updateAttemptedStatus = (attemptedIds = []) => {
//     if (!Array.isArray(attemptedIds) || attemptedIds.length === 0) return;

//     setQuestionStatus((prev = {}) => {
//       const updated = { ...prev };

//       attemptedIds.forEach((qid) => {
//         updated[qid] = "answered";
//       });

//       return updated;
//     });
//   };







//   // const handleSave = async (transcript = questionTranscript) => {
//   //   const { audioBlob,videoBlob } = await stopRecording();

//   //   const user_id = localStorage.getItem("username") || "1";
//   //   const vivaQuestionId = questions[currentQuestion].Id
//   //   const QuestionDescription = questions[currentQuestion]?.QuestionDescription
//   //   console.log(user_id, vivaQuestionId, QuestionDescription, "Here")
//   //   const result = await submitRecordingForQuestion(audioBlob, videoBlob,user_id, vivaQuestionId, QuestionDescription, ee_id,transcript);

//   //   if (result.success) {
//   //     setQuestionStatus((prev = {}) => ({
//   //       ...(prev || {}),
//   //       [questions[currentQuestion].Id]: "answered"
//   //     }));


//   //     setShowPopup(false);

//   //     if (currentQuestion < questions.length - 1) {
//   //       setCurrentQuestion(currentQuestion + 1);
//   //     }
//   //   } else {
//   //     alert("Failed to save this answer: " + result.error);
//   //   }
//   // };


//   const handleSave = async (transcript = questionTranscript) => {
//     if (examFinalizedRef.current) {
//       console.warn("⏭️ Exam already finalized, ignoring save");
//       return;
//     }

//     const { audioBlob, videoBlob } = await stopRecording();

//     const user_id = localStorage.getItem("username") || "1";
//     const vivaQuestionId = questions[currentQuestion].Id;
//     const QuestionDescription = questions[currentQuestion]?.QuestionDescription;
//     const result = await submitRecordingForQuestion(
//       audioBlob,
//       videoBlob,
//       user_id,
//       vivaQuestionId,
//       QuestionDescription,
//       ee_id,
//       transcript
//     );

//     if (result.success) {
//       setQuestionStatus((prev = {}) => ({
//         ...(prev || {}),
//         [questions[currentQuestion].Id]: "answered",
//       }));

//       setShowPopup(false);

//       if (currentQuestion < questions.length - 1) {
//         setCurrentQuestion(currentQuestion + 1);
//       }
//       return result;
//     } else if (!examFinalizedRef.current) {
//       alert("Failed to save this answer: " + result.error);
//     }

//     return result;
//   };


// const handleTimeUp = async () => {
//     if (examFinalizedRef.current) return;

//     setIsTimeUp(true);
//     console.log("⏰ Time's up! Auto-saving and submitting...");

//     if (isRecording) {
//       await handleSave(questionTranscript);
//     } else {
//       setShowPopup(false);
//       setShowSavingPopup(false);
//     }

//     // Wait for any in-flight question submission to complete before triggering final auto-submit
//     while (questionSubmitRef.current) {
//       await new Promise((resolve) => setTimeout(resolve, 100));
//     }

//     if (examFinalizedRef.current) return;

//     setSubmitDialog({
//       open: true,
//       isAuto: true,
//       autoReason: "timeout",
//     });

//   //     const response = await fetch(`/viva/submit_viva_exam/`, {
//   //       method: "POST",
//   //       headers: {
//   //         "Content-Type": "application/json",
//   //       },
//   //     });

//   //     const data = await response.json();

//   //     if (response.ok) {
//   //       console.log("✅ Report generated successfully:", data);
//   //       // alert("Report generated successfully!");
//   //       setShowSuccess(true);
//   //     } else {
//   //       console.error("❌ Error generating report:", data.error);
//   //       alert("Failed to generate report: " + data.error);
//   //     }
//   //   } catch (error) {
//   //     console.error("⚠️ Network or server error:", error);
//   //     alert("Something went wrong: " + error.message);
//   //   }
//   // };

//   const safeParseJson = async (response) => {
//     const contentType = response.headers.get("content-type") || "";
//     if (!contentType.includes("application/json")) {
//       const text = await response.text();
//       throw new Error(
//         `Server returned a non-JSON response (status ${response.status}): ${text.slice(0, 150)}`
//       );
//     }
//     return response.json();
//   };

//   const handleFinalSubmit = useCallback(async () => {
//     if (isSubmitting || examFinalizedRef.current) return;

//     try {
//       setIsSubmitting(true);

//       const response = await fetch(`/viva/submit_viva_exam/`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//       });

//       const data = await safeParseJson(response);

//       if (response.ok) {
//         console.log("✅ Report generated successfully:", data);
//         examFinalizedRef.current = true; // 🔒 lock out any further save/submit calls
//         setSubmitDialog({ open: false, isAuto: false, autoReason: null });
//         setShowPopup(false);
//         setShowSuccess(true);
//       } else {
//         throw new Error(data.error || "Submission failed");
//       }
//     } catch (error) {
//       console.error("❌ Submit error:", error);
//       alert("Submission failed. Please try again.");
//       setIsSubmitting(false);
//     }
//   }, [isSubmitting]);


//   const escTriggeredRef = useRef(false);
//   const pendingViolationRef = useRef(null);



//   // ✅ When popup

//   useEffect(() => {
//     const onFullscreenChange = () => {
//       if (!document.fullscreenElement) {
//         if (escTriggeredRef.current) {
//           escTriggeredRef.current = false;
//           return;
//         }

//         triggerViolation(
//           "EXIT_FULLSCREEN",
//           "You exited fullscreen. Assessment must remain in fullscreen."
//         );
//       }
//     };

//     const onVisibilityChange = () => {
//       if (document.hidden) {
//         pendingViolationRef.current = {
//           type: "TAB_SWITCH",
//           message: "Switching tabs is not allowed during Viva."
//         };

//         triggerViolation(
//           "TAB_SWITCH",
//           "Switching tabs is not allowed during Viva."
//         );
//       } else {
//         if (pendingViolationRef.current) {
//           setViolationMessage(pendingViolationRef.current.message);
//           setViolationOpen(true);
//           pendingViolationRef.current = null;
//         }
//       }
//     };

//     const onKeyDown = (e) => {
//       if (e.key === "Escape") {
//         e.preventDefault();
//         escTriggeredRef.current = true;

//         triggerViolation("ESCAPE_KEY", "ESC key is not allowed during Viva.");
//         return;
//       }

//       const isRefresh =
//         (e.ctrlKey && e.key.toLowerCase() === "r") ||
//         (e.metaKey && e.key.toLowerCase() === "r") ||
//         e.key === "F5";

//       if (isRefresh) {
//         e.preventDefault();
//         triggerViolation(
//           "PAGE_REFRESH",
//           "Page refresh is not allowed during Viva."
//         );
//       }
//     };

//     const blockBackNavigation = () => {
//       window.history.pushState(null, "", window.location.href);
//     };

//     const onPopState = () => {
//       blockBackNavigation();
//       triggerViolation(
//         "BACK_NAVIGATION",
//         "Back navigation is not allowed during Viva."
//       );
//     };

//     blockBackNavigation();

//     document.addEventListener("fullscreenchange", onFullscreenChange);
//     document.addEventListener("visibilitychange", onVisibilityChange);
//     window.addEventListener("keydown", onKeyDown);
//     window.addEventListener("popstate", onPopState);

//     return () => {
//       document.removeEventListener("fullscreenchange", onFullscreenChange);
//       document.removeEventListener("visibilitychange", onVisibilityChange);
//       window.removeEventListener("keydown", onKeyDown);
//       window.removeEventListener("popstate", onPopState);
//     };
//   }, [triggerViolation]);

//   //  closes (either manually or auto)

//   const handlePopupClose = () => {
//     if (document.fullscreenElement) {
//       document.exitFullscreen().catch(() => { });
//     }
//     setShowSuccess(false);
//     navigate("/users/dashboard", {
//       state: { questions, questionStatus },
//     });
//   };

//   useEffect(() => {
//     if (violationCount >= MAX_VIOLATIONS) {
//       setShowPopup(false);
//       setShowSavingPopup(false);
//     }
//   }, [violationCount]);

//   const handleDialogConfirm = useCallback(() => {
//     setSubmitDialog({ open: false, isAuto: false, autoReason: null });
//     handleFinalSubmit();
//   }, [handleFinalSubmit]); // handleFinalSubmit itself may change, but we'll stabilize it too (next step)

//   // Recording timer
//   useEffect(() => {
//     let interval = null;
//     if (isRecording && recordingStartTime) {
//       interval = setInterval(() => {
//         setRecordingDuration(
//           Math.floor((Date.now() - recordingStartTime) / 1000)
//         );
//       }, 1000);
//     }
//     return () => interval && clearInterval(interval);
//   }, [isRecording, recordingStartTime]);

//   // Stop streams on unmount
//   useEffect(() => {
//     return () => {
//       if (audioStream) audioStream.getTracks().forEach((t) => t.stop());
//       if (stream) stream.getTracks().forEach((t) => t.stop());
//     };
//   }, [audioStream, stream]);




//   return (
//     <Box
//       className="exam-card"
//       sx={{
//         position: "fixed",

//         // 🔥 OVERSCAN FIX (critical)
//         top: "-2px",
//         left: "-2px",
//         width: "calc(100vw + 4px)",
//         height: "calc(100vh + 4px)",

//         overflow: "hidden",
//         backgroundColor: "#edf2f7",
//         padding: 2,
//         boxSizing: "border-box",
//         transform: "translateZ(0)",
//         backfaceVisibility: "hidden",
//       }}
//     >

//       <ExamName />
//       <ExamHeader
//         currentQuestion={currentQuestion}
//         totalQuestions={questions.length}
//         isRecording={isRecording}
//         questionStatus={questionStatus}
//         timeLeft={timeLeft}
//       />

//       <QuestionTabs
//         currentQuestion={currentQuestion}
//         setCurrentQuestion={setCurrentQuestion}
//         questionStatus={questionStatus}
//         questions={questions}
//       />

//       {!showPopup && !showSuccess && (
//         <Box
//           sx={{
//             border: "1px solid var(--border, #ccc)",
//             textAlign: "center",
//             mt: 2,
//             flexGrow: 1,
//             display: "flex",
//             flexDirection: "column",
//             justifyContent: "flex-start",
//             pt: 4,
//             pb: 6,
//           }}
//         >
//           <Box
//             className="question-text"
//             sx={{ fontSize: 20, fontWeight: 600, mb: 4 }}
//           >
//             {questionStatus[qId] === "not-started" && (
//               <>
//                 <Box sx={{ pt: 5 }}>{"Are you ready to answer this question?"}</Box>
//                 <Box sx={{ fontSize: 40, mb: 2, color: "var(--brand)" }}>
//                   <i className="fa fa-question-circle"></i>
//                 </Box>
//               </>
//             )}
//             {questionStatus[qId] === "recording" &&
//               questions[currentQuestion]?.QuestionDescription}
//             {questionStatus[qId] === "answered" &&
//               "✅ Successfully saved your response"}
//           </Box>

//           {questionStatus[qId] !== "answered" && (
//             <Button className="answer-button" onClick={handleAnswerClick}>
//               Answer
//             </Button>
//           )}
//         </Box>
//       )}

//       {showPopup && (
//         <div
//           style={{
//             position: "fixed",
//             inset: 0,
//             width: "100vw",
//             height: "100vh",
//             background: "rgba(0,0,0,0.6)",
//             zIndex: 99999,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           <QuestionPopup
//             question={questions[currentQuestion]}
//             currentQuestion={currentQuestion}
//             isRecording={isRecording}
//             stream={stream}
//             audioStream={audioStream}
//             startRecording={startRecording}
//             transcript={questionTranscript}
//             setTranscript={setQuestionTranscript}
//             handleSave={handleSave}
//             onClose={() => setShowPopup(false)}
//             onSaveStart={() => setShowSavingPopup(true)}
//             onSaveEnd={() => setShowSavingPopup(false)}
//           />
//         </div>
//       )}

//       {showSavingPopup && (
//         <Box
//           sx={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100vw",
//             height: "100vh",
//             background: "rgba(0,0,0,0.4)",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             zIndex: 9999,
//           }}
//         >
//           <Box
//             sx={{
//               background: "#fff",
//               padding: 4,
//               borderRadius: 2,
//               minWidth: 280,
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               gap: 2,
//             }}
//           >
//             <Box
//               sx={{
//                 width: 40,
//                 height: 40,
//                 border: "4px solid #e2e8f0",
//                 borderTop: "4px solid #f79033",
//                 borderRadius: "50%",
//                 animation: "spin 1s linear infinite",
//               }}
//             />
//             <Typography sx={{ fontSize: 15, fontWeight: 600 }}>
//               Please wait
//             </Typography>
//             <Typography sx={{ fontSize: 13, color: "#666" }}>
//               Saving your response…
//             </Typography>
//           </Box>
//         </Box>
//       )}


//       {/* {violationOpen && (
//   <VivaViolationDialog
//     message={violationMessage}
//     count={violationCount}
//     max={3}
//     onContinue={() => {
//       setViolationOpen(false);
//       document.documentElement.requestFullscreen().catch(() => {});
//     }}
//   />
// )} */}

//       {violationOpen && violationCount < MAX_VIOLATIONS && (
//         <VivaViolationDialog
//           message={violationMessage}
//           count={violationCount}
//           max={3}
//           onContinue={() => {
//             setViolationOpen(false);
//             document.documentElement.requestFullscreen().catch(() => { });
//           }}
//         />
//       )}




//       {/* Submit Confirmation Dialog */}
//       <SubmitVivaDialog
//         open={submitDialog.open}
//         isAuto={submitDialog.isAuto}
//         autoReason={submitDialog.autoReason}
//         onClose={() => setSubmitDialog({ open: false, isAuto: false, autoReason: null })}
//         isSubmitting={isSubmitting}
//         onConfirm={handleDialogConfirm}
//         questions={questions}
//         questionStatus={questionStatus}
//       />

//       {showSuccess && (
//         <div
//           style={{
//             position: "fixed",
//             inset: 0,
//             width: "100vw",
//             height: "100vh",
//             background: "rgba(0,0,0,0.6)",
//             zIndex: 99999,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           <SubmitSuccessPopup onClose={handlePopupClose} autoClose={handlePopupClose} />
//         </div>
//       )}

//       {/* {!showSuccess && (
//         <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
//           <Button className="submit-final-button" onClick={handleFinalSubmit}>
//             Submit
//           </Button>
//         </Box>
//       )} */}
//       {!showSuccess && (
//         <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
//           <Button
//             className="submit-final-button"
//             variant="contained"
//             color="error"
//             size="large"
//             // onClick={() => setShowSubmitDialog(true)}
//             onClick={() => {
//               setSubmitDialog({
//                 open: true,
//                 isAuto: false,
//                 autoReason: null,
//               });
//             }}
//           >
//             Submit
//           </Button>
//         </Box>
//       )}
//     </Box>
//   );
// };




import React, { useState, useEffect, useCallback } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ExamHeader } from "./ExamHeader";
import { QuestionTabs } from "./QuestionTabs";
import { QuestionPopup } from "./QuestionPopup";
import { SubmitSuccessPopup } from "./SubmitSuccessPopup";
import { useRecording } from "./useRecording";
import { ExamName } from "./ExamName";
import "./VivaExam.css";
import axios from "axios";
import { useParams } from "react-router-dom";
import Config from "../config";
import { useRef, useMemo } from "react";
import SubmitVivaDialog from "./SubmitVivaDialog";
import { useVivaSecurity } from "./vivaSecurity";
import { VivaViolationDialog } from "./VivaViolationDialog";



const User_URL = Config.user_url;
export const RightCard = ({
  ee_id,
  currentQuestion,
  setCurrentQuestion,
  questionStatus,
  setQuestionStatus,
  isRecording,
  setIsRecording,
  stream,
  setStream,
  audioStream,
  setAudioStream,
  

}) => {
  const navigate = useNavigate();

  const [recordingStartTime, setRecordingStartTime] = useState(null);
  const [recordingDuration, setRecordingDuration] = useState(0);
  const [showSuccess, setShowSuccess] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [timeLeft, setTimeLeft] = useState(0); // total exam time left (in seconds)
  const [timerReady, setTimerReady] = useState(false);
  const [isTimeUp, setIsTimeUp] = useState(false);
  const wsRef = useRef(null);
  const timerRef = useRef(null);
  const vivaId = useMemo(() => localStorage.getItem("vivaExamSessionId") || "", []);
  const [duration, setDuration] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [examCompleted, setExamCompleted] = useState(false);
  const qId = questions[currentQuestion]?.Id;
  const [submitDialog, setSubmitDialog] = useState({
    open: false,
    isAuto: false,
    autoReason: null,
  });
  //   const [violationPopup, setViolationPopup] = useState(null);
  // const [violationCount, setViolationCount] = useState(0);
  const [violationOpen, setViolationOpen] = useState(false);
  const [violationMessage, setViolationMessage] = useState("");
  const [violationCount, setViolationCount] = useState(0);
  const MAX_VIOLATIONS = 3;
  // const [forceSubmit, setForceSubmit] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const [questionTranscript, setQuestionTranscript] = useState("");
  const [showSavingPopup, setShowSavingPopup] = useState(false);
  const [savingPopupMessage, setSavingPopupMessage] = useState("Saving your response...");
    const videoRecorderRef = useRef(null);
  const videoChunksRef = useRef([]);
    const examFinalizedRef = useRef(false);
    const timeUpTriggeredRef = useRef(false);
    const timerReadyRef = useRef(false);
    const questionSaveInProgressRef = useRef(false);
    const questionTranscriptRef = useRef("");
    const timeLeftRef = useRef(0);
    const currentQuestionRef = useRef(0);
    const questionsRef = useRef([]);
    const isRecordingRef = useRef(false);



  const allQuestionsAnswered = Object.values(questionStatus).every(
    (status) => status === "answered"
  );

  const protocol = window.location.protocol === "https:" ? "wss" : "ws";
  const host = window.location.host;

  useEffect(() => {
    questionTranscriptRef.current = questionTranscript;
  }, [questionTranscript]);

  useEffect(() => {
    timeLeftRef.current = timeLeft;
  }, [timeLeft]);

  useEffect(() => {
    currentQuestionRef.current = currentQuestion;
  }, [currentQuestion]);

  useEffect(() => {
    questionsRef.current = questions;
  }, [questions]);

  useEffect(() => {
    isRecordingRef.current = isRecording;
  }, [isRecording]);


  const { startRecording, stopRecording, submitRecordingForQuestion, isSubmittingRef: questionSubmitRef } = useRecording({
    setAudioStream,
    setStream,
    setIsRecording,
    setRecordingStartTime,
    setRecordingDuration,
    currentQuestion,
    setQuestionStatus,
    currentVivaQuestionId: questions[currentQuestion]?.Id,
    ee_id
  });



  // const { localViolation } = useVivaSecurity(
  //   ee_id,
  //   handleForceSubmit,
  //   setViolationPopup,
  //   setViolationCount
  // );

  const handleForceSubmit = (reason = "malpractice") => {
    // 🔒 FORCE
    setSubmitDialog({
      open: true,
      isAuto: true,
      autoReason: reason,
    });
  };

  const { triggerViolation } = useVivaSecurity(
    ee_id,
    handleForceSubmit,
    setViolationOpen,
    setViolationMessage,
    setViolationCount,
    // setShowSubmitDialog
  );








  useEffect(() => {
    if (!ee_id) return;

    const fetchDuration = async () => {
      try {
        const response = await axios.get(`/viva/get-duration/${ee_id}/`);
        setDuration(response.data.duration);
        console.log(response.data.duration, "kkkkkkkkkkkkkkkkkkk");
      } catch (error) {
        console.error("Error fetching duration:", error);
      }
    };

    fetchDuration();
  }, [ee_id]);



  useEffect(() => {
    let stored = null;

    try {
      stored = JSON.parse(localStorage.getItem("vivaQIds"));
    } catch (e) {
      stored = null;
    }

    if (Array.isArray(stored) && stored.length > 0) {
      setQuestions(stored);

      const statusDict = {};
      stored.forEach(q => {
        statusDict[q.Id] = "not-started";
      });
      setQuestionStatus(statusDict);
    } else {
      setQuestions([]); // ALWAYS ensure array
      setQuestionStatus({});
      console.warn("Invalid vivaQIds in localStorage");
    }

    setLoading(false);
  }, []);


  // const handleAnswerClick = async () => {
  //   const qId = questions[currentQuestion]?.Id;

  //   // 🚫 BLOCK answered questions
  //   if (qId && questionStatus[qId] === "answered") {
  //     alert("You have already answered this question.");
  //     return;
  //   }
  //   try {

  //     console.log("vivaQIds:", questions);
  //     const QuestionId = questions[currentQuestion]?.Id;
  //     console.log("QuestionId:", QuestionId, "Current Question:", currentQuestion);
  //     if (!QuestionId) {
  //       alert("Question ID not found in local storage!");
  //       return;
  //     }

  //     const response = await axios.get(
  //       `/employee/get-question/?question_id=${QuestionId}`
  //     );
  //     console.log("API response:", response.data);

  //     if (
  //       response.status === 200 &&
  //       response.data &&
  //       Array.isArray(response.data.questions) &&
  //       response.data.questions.length > 0
  //     ) {
  //       const fetchedQuestion = response.data.questions[0];
  //       setQuestions((prev = []) => {
  //         const updated = Array.isArray(prev) ? [...prev] : [];
  //         updated[currentQuestion] = {
  //           Id: QuestionId,
  //           ...(prev?.[currentQuestion] || {}),
  //           ...fetchedQuestion,
  //         };
  //         return updated;
  //       });

  //       console.log("Updated questions:", questions);
  //       setShowPopup(true);
  //       await startRecording();
  //     } else {
  //       alert("No question data received from server.");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching question:", error);
  //     alert("Unable to fetch question. Please try again.");
  //   }
  // };



  const handleAnswerClick = async () => {
        if (examFinalizedRef.current || timeUpTriggeredRef.current) return;

    try {

      questionTranscriptRef.current = "";
      setQuestionTranscript("");
      const storedQuestions =
        JSON.parse(localStorage.getItem("vivaQIds")) || [];

      const QuestionId = storedQuestions[currentQuestion]?.Id;

      if (!QuestionId) {
        alert("Question ID not found!");
        return;
      }

      if (questionStatus[QuestionId] === "answered") {
        alert("You have already answered this question.");
        return;
      }

      const response = await axios.get(
        `/employee/get-question/?question_id=${QuestionId}`
      );

      if (
        response.status === 200 &&
        Array.isArray(response.data.questions) &&
        response.data.questions.length > 0
      ) {
        const fetchedQuestion = response.data.questions[0];

        setQuestions((prev = []) => {
          const updated = [...prev];

          updated[currentQuestion] = {
            Id: QuestionId,
            ...(prev?.[currentQuestion] || {}),
            ...fetchedQuestion,
          };

          return updated;
        });

        setShowPopup(true);
        await startRecording();
      } else {
        alert("No question data received from server.");
      }
    } catch (error) {
      console.error("Error fetching question:", error);
      alert("Unable to fetch question. Please try again.");
    }
  };
  useEffect(() => {
    if (!duration || timerReadyRef.current) return;
    console.log("Updated duration:", duration);
    const stored = Number(duration) * 60;
    console.log("Stored durationSeconds:", stored);
    if (Number.isFinite(stored) && stored > 0) {
      timerReadyRef.current = true;
      setTimerReady(true);
      setTimeLeft(parseInt(stored, 10));
    }
  }, [duration]);

  // useEffect(() => {
  //   if (!vivaId) return;
  //   const ws = new WebSocket(`ws://localhost:8000/ws/viva_portal/${ee_id}/`);
  //   // const ws = new WebSocket(`${protocol}://${host}/ws/viva_portal/${ee_id}/`);
  //   wsRef.current = ws;
  //   ws.onmessage = (e) => {
  //     const data = JSON.parse(e.data);

  //     // --- INIT FROM BACKEND ---
  //     if (data.action === "init") {

  //       if (data.time_left !== undefined) {
  //         setTimeLeft(data.time_left);
  //       }

  //       if (data.attempted_questions !== undefined) {
  //         updateAttemptedStatus(data.attempted_questions);
  //       }

  //       // receive current question logic
  //       if (data.current_question) {
  //         const { currentQuestionIndex, currentQuestion, isCompleted } = data.current_question;

  //         setCurrentQuestionIndex(currentQuestionIndex);
  //         setCurrentQuestion(currentQuestion);
  //         setExamCompleted(isCompleted);
  //       }
  //     }

  //     // --- TIMER UPDATE FROM BACKEND ---
  //     if (data.action === "time_update") {

  //       if (data.time_left !== undefined) {
  //         setTimeLeft(data.time_left);
  //       }

  //       if (data.attempted_questions !== undefined) {
  //         updateAttemptedStatus(data.attempted_questions);
  //       }
  //     }
  //   };


  //   ws.onclose = () => console.log("⛔ Timer WebSocket closed");

  //   return () => ws.close();
  // }, [vivaId]);


  useEffect(() => {
  if (!ee_id) {
    console.warn("⚠️ No ee_id, skipping WebSocket connection");
    return;
  }

  // Close existing connection if any
  if (wsRef.current && (wsRef.current.readyState === WebSocket.OPEN || wsRef.current.readyState === WebSocket.CONNECTING)) {
    wsRef.current.close();
    wsRef.current = null;
  }

  const protocol = window.location.protocol === "https:" ? "wss" : "ws";
  const host = window.location.host;

  const ws = new WebSocket(`${protocol}://${host}/ws/viva_portal/${ee_id}/`);
  // const ws = new WebSocket(`ws://localhost:8000/ws/viva_portal/${ee_id}/`);
  wsRef.current = ws;
  
  let isMounted = true;

  ws.onopen = () => {
    if (isMounted) {
      console.log("✅ Viva Portal WebSocket connected");
      // Send initial sync request
      ws.send(JSON.stringify({ action: "sync", ee_id }));
    }
  };

  ws.onmessage = (e) => {
    if (!isMounted) return;
    
    try {
      const data = JSON.parse(e.data);

      // --- INIT FROM BACKEND ---
      if (data.action === "init") {
        if (data.time_left !== undefined) {
          const nextTimeLeft = Number(data.time_left);
          if (
            !examFinalizedRef.current &&
            !timeUpTriggeredRef.current &&
            Number.isFinite(nextTimeLeft) &&
            (nextTimeLeft > 0 || timerReadyRef.current)
          ) {
            timerReadyRef.current = true;
            setTimerReady(true);
            setTimeLeft(Math.max(nextTimeLeft, 0));
          }
        }

        if (data.attempted_questions !== undefined) {
          updateAttemptedStatus(data.attempted_questions);
        }

        if (data.current_question) {
          const { currentQuestionIndex, currentQuestion, isCompleted } = data.current_question;
          setCurrentQuestionIndex(currentQuestionIndex);
          setCurrentQuestion(currentQuestion);
          setExamCompleted(isCompleted);
        }
      }

      // --- TIMER UPDATE FROM BACKEND ---
      if (data.action === "time_update") {
        if (data.time_left !== undefined) {
          const nextTimeLeft = Number(data.time_left);
          if (
            !examFinalizedRef.current &&
            !timeUpTriggeredRef.current &&
            Number.isFinite(nextTimeLeft) &&
            (nextTimeLeft > 0 || timerReadyRef.current)
          ) {
            timerReadyRef.current = true;
            setTimerReady(true);
            setTimeLeft(Math.max(nextTimeLeft, 0));
          }
        }

        if (data.attempted_questions !== undefined) {
          updateAttemptedStatus(data.attempted_questions);
        }
      }
    } catch (error) {
      console.error("❌ Error parsing WebSocket message:", error);
    }
  };

  ws.onclose = (event) => {
    if (isMounted) {
      console.log("⛔ Timer WebSocket closed", event.code, event.reason);
    }
  };

  ws.onerror = (err) => {
    console.error("❌ WebSocket error:", err);
  };

  // Cleanup function
  return () => {
    isMounted = false;
    if (wsRef.current) {
      if (wsRef.current.readyState === WebSocket.OPEN || wsRef.current.readyState === WebSocket.CONNECTING) {
        wsRef.current.close();
      }
      wsRef.current = null;
    }
  };
}, [ee_id]); // Changed from [vivaId] to [ee_id]


  useEffect(() => {
    if (examFinalizedRef.current || !timerReady || questions.length === 0) return;

    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    timerRef.current = setInterval(() => {
      if (examFinalizedRef.current || timeUpTriggeredRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
        return;
      }

      const next = Math.max(timeLeftRef.current - 1, 0);
      timeLeftRef.current = next;
      setTimeLeft(next);

      if (wsRef.current?.readyState === WebSocket.OPEN) {
        wsRef.current.send(JSON.stringify({ action: "time_update", time_left: next }));
      }

      if (next <= 0) {
        timeUpTriggeredRef.current = true;
        clearInterval(timerRef.current);
        timerRef.current = null;
        handleTimeUp();
      }
    }, 1000);

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [timerReady, questions.length]);

  useEffect(() => {
    const attempted = JSON.parse(localStorage.getItem("attemptedQuestions")) || [];
    updateAttemptedStatus(attempted);
  }, []);

  useEffect(() => {
    if (showPopup || showSavingPopup || showSuccess || submitDialog.open || violationOpen) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => document.body.classList.remove("modal-open");
  }, [showPopup, showSavingPopup, showSuccess, submitDialog.open, violationOpen]);

  const updateAttemptedStatus = (attemptedIds = []) => {
    if (!Array.isArray(attemptedIds) || attemptedIds.length === 0) return;

    setQuestionStatus((prev = {}) => {
      const updated = { ...prev };

      attemptedIds.forEach((qid) => {
        updated[qid] = "answered";
      });

      return updated;
    });
  };







  // const handleSave = async (transcript = questionTranscript) => {
  //   const { audioBlob,videoBlob } = await stopRecording();

  //   const user_id = localStorage.getItem("username") || "1";
  //   const vivaQuestionId = questions[currentQuestion].Id
  //   const QuestionDescription = questions[currentQuestion]?.QuestionDescription
  //   console.log(user_id, vivaQuestionId, QuestionDescription, "Here")
  //   const result = await submitRecordingForQuestion(audioBlob, videoBlob,user_id, vivaQuestionId, QuestionDescription, ee_id,transcript);

  //   if (result.success) {
  //     setQuestionStatus((prev = {}) => ({
  //       ...(prev || {}),
  //       [questions[currentQuestion].Id]: "answered"
  //     }));


  //     setShowPopup(false);

  //     if (currentQuestion < questions.length - 1) {
  //       setCurrentQuestion(currentQuestion + 1);
  //     }
  //   } else {
  //     alert("Failed to save this answer: " + result.error);
  //   }
  // };


  const handleSave = async (transcript = questionTranscript, questionIndex = currentQuestion) => {
    if (examFinalizedRef.current) {
      console.warn("⏭️ Exam already finalized, ignoring save");
      return;
    }

    questionSaveInProgressRef.current = true;

    try {
      const activeQuestions = questionsRef.current;
      const activeQuestion = activeQuestions[questionIndex];

      if (!activeQuestion?.Id) {
        return { success: false, error: "Question ID not found" };
      }

      const { audioBlob, videoBlob } = await stopRecording();

      const user_id = localStorage.getItem("username") || "1";
      const vivaQuestionId = activeQuestion.Id;
      const QuestionDescription = activeQuestion?.QuestionDescription;
      const result = await submitRecordingForQuestion(
        audioBlob,
        videoBlob,
        user_id,
        vivaQuestionId,
        QuestionDescription,
        ee_id,
        transcript
      );

      if (result.success) {
        setQuestionStatus((prev = {}) => ({
          ...(prev || {}),
          [activeQuestion.Id]: "answered",
        }));

        setShowPopup(false);

        if (questionIndex === currentQuestionRef.current && questionIndex < activeQuestions.length - 1) {
          setCurrentQuestion(questionIndex + 1);
        }
        return result;
      } else if (!examFinalizedRef.current) {
        alert("Failed to save this answer: " + result.error);
      }

      return result;
    } finally {
      questionSaveInProgressRef.current = false;
    }
  };


  const waitForQuestionSubmission = async () => {
    while (questionSaveInProgressRef.current || questionSubmitRef.current) {
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
  };

const handleTimeUp = async () => {
    if (examFinalizedRef.current) return;

    setIsTimeUp(true);
    setShowPopup(false);
    setSavingPopupMessage("Saving your response...");
    setShowSavingPopup(true);
    console.log("⏰ Time's up! Auto-saving and submitting...");

      if (questionSaveInProgressRef.current || questionSubmitRef.current) {
        setShowPopup(false);
        setSavingPopupMessage("Saving your response...");
        setShowSavingPopup(true);
        await waitForQuestionSubmission();
        setShowSavingPopup(false);
      } else if (isRecordingRef.current) {
        setSavingPopupMessage("Saving your response...");
        setShowSavingPopup(true);
      await handleSave(questionTranscriptRef.current, currentQuestionRef.current);
      await waitForQuestionSubmission();
      setShowSavingPopup(false);
    } else {
      setShowPopup(false);
      setShowSavingPopup(false);
    }

    if (examFinalizedRef.current) return;

    setSubmitDialog({
      open: true,
      isAuto: true,
      autoReason: "timeout",
    });
  }; // <-- THIS CLOSING BRACE WAS MISSING

  const handleFinalSubmit = useCallback(async () => {
    if (isSubmitting || examFinalizedRef.current) return;

    try {
      setIsSubmitting(true);
      if (submitDialog.isAuto) {
        setSavingPopupMessage("Submitting your assessment...");
        setShowSavingPopup(true);
      }

      const response = await axios.post(
        `/viva/submit_viva_exam/`,
        {},
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      const data = response.data || {};

      if (response.status >= 200 && response.status < 300) {
        console.log("✅ Report generated successfully:", data);
        examFinalizedRef.current = true; // 🔒 lock out any further save/submit calls
        setSubmitDialog({ open: false, isAuto: false, autoReason: null });
        setShowPopup(false);
        setShowSavingPopup(false);
        setShowSuccess(true);
      } else {
        throw new Error(data.error || "Submission failed");
      }
    } catch (error) {
      console.error("❌ Submit error:", error);
      alert("Submission failed. Please try again.");
      setShowSavingPopup(false);
      setIsSubmitting(false);
    }
  }, [isSubmitting, submitDialog.isAuto]);


  const escTriggeredRef = useRef(false);
  const pendingViolationRef = useRef(null);



  // ✅ When popup

  useEffect(() => {
    const onFullscreenChange = () => {
      if (!document.fullscreenElement) {
        if (escTriggeredRef.current) {
          escTriggeredRef.current = false;
          return;
        }

        triggerViolation(
          "EXIT_FULLSCREEN",
          "You exited fullscreen. Assessment must remain in fullscreen."
        );
      }
    };

    const onVisibilityChange = () => {
      if (document.hidden) {
        pendingViolationRef.current = {
          type: "TAB_SWITCH",
          message: "Switching tabs is not allowed during Viva."
        };

        triggerViolation(
          "TAB_SWITCH",
          "Switching tabs is not allowed during Viva."
        );
      } else {
        if (pendingViolationRef.current) {
          setViolationMessage(pendingViolationRef.current.message);
          setViolationOpen(true);
          pendingViolationRef.current = null;
        }
      }
    };

    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        escTriggeredRef.current = true;

        triggerViolation("ESCAPE_KEY", "ESC key is not allowed during Viva.");
        return;
      }

      const isRefresh =
        (e.ctrlKey && e.key.toLowerCase() === "r") ||
        (e.metaKey && e.key.toLowerCase() === "r") ||
        e.key === "F5";

      if (isRefresh) {
        e.preventDefault();
        triggerViolation(
          "PAGE_REFRESH",
          "Page refresh is not allowed during Viva."
        );
      }
    };

    const blockBackNavigation = () => {
      window.history.pushState(null, "", window.location.href);
    };

    const onPopState = () => {
      blockBackNavigation();
      triggerViolation(
        "BACK_NAVIGATION",
        "Back navigation is not allowed during Viva."
      );
    };

    blockBackNavigation();

    document.addEventListener("fullscreenchange", onFullscreenChange);
    document.addEventListener("visibilitychange", onVisibilityChange);
    window.addEventListener("keydown", onKeyDown);
    window.addEventListener("popstate", onPopState);

    return () => {
      document.removeEventListener("fullscreenchange", onFullscreenChange);
      document.removeEventListener("visibilitychange", onVisibilityChange);
      window.removeEventListener("keydown", onKeyDown);
      window.removeEventListener("popstate", onPopState);
    };
  }, [triggerViolation]);

  //  closes (either manually or auto)

  const handlePopupClose = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen().catch(() => { });
    }
    setShowSuccess(false);
    navigate("/users/dashboard", {
      state: { questions, questionStatus },
    });
  };

  useEffect(() => {
    if (violationCount >= MAX_VIOLATIONS) {
      setShowPopup(false);
      setShowSavingPopup(false);
    }
  }, [violationCount]);

  const handleDialogConfirm = useCallback(() => {
    setSubmitDialog({ open: false, isAuto: false, autoReason: null });
    handleFinalSubmit();
  }, [handleFinalSubmit]); // handleFinalSubmit itself may change, but we'll stabilize it too (next step)

  // Recording timer
  useEffect(() => {
    let interval = null;
    if (isRecording && recordingStartTime) {
      interval = setInterval(() => {
        setRecordingDuration(
          Math.floor((Date.now() - recordingStartTime) / 1000)
        );
      }, 1000);
    }
    return () => interval && clearInterval(interval);
  }, [isRecording, recordingStartTime]);

  // Stop streams on unmount
  useEffect(() => {
    return () => {
      if (audioStream) audioStream.getTracks().forEach((t) => t.stop());
      if (stream) stream.getTracks().forEach((t) => t.stop());
    };
  }, [audioStream, stream]);




  return (
    <Box
      className="exam-card"
      sx={{
        position: "fixed",

        // 🔥 OVERSCAN FIX (critical)
        top: "-2px",
        left: "-2px",
        width: "calc(100vw + 4px)",
        height: "calc(100vh + 4px)",

        overflow: "hidden",
        backgroundColor: "#edf2f7",
        padding: 2,
        boxSizing: "border-box",
        transform: "translateZ(0)",
        backfaceVisibility: "hidden",
      }}
    >

      <ExamName />
      <ExamHeader
        currentQuestion={currentQuestion}
        totalQuestions={questions.length}
        isRecording={isRecording}
        questionStatus={questionStatus}
        timeLeft={timeLeft}
      />

      <QuestionTabs
        currentQuestion={currentQuestion}
        setCurrentQuestion={setCurrentQuestion}
        questionStatus={questionStatus}
        questions={questions}
      />

      {!showPopup && !showSuccess && (
        <Box
          sx={{
            border: "1px solid var(--border, #ccc)",
            textAlign: "center",
            mt: 2,
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            pt: 4,
            pb: 6,
          }}
        >
          <Box
            className="question-text"
            sx={{ fontSize: 20, fontWeight: 600, mb: 4 }}
          >
            {questionStatus[qId] === "not-started" && (
              <>
                <Box sx={{ pt: 5 }}>{"Are you ready to answer this question?"}</Box>
                <Box sx={{ fontSize: 40, mb: 2, color: "var(--brand)" }}>
                  <i className="fa fa-question-circle"></i>
                </Box>
              </>
            )}
            {questionStatus[qId] === "recording" &&
              questions[currentQuestion]?.QuestionDescription}
            {questionStatus[qId] === "answered" &&
              "✅ Successfully saved your response"}
          </Box>

          {questionStatus[qId] !== "answered" && (
            <Button
              className="answer-button"
              onClick={handleAnswerClick}
              disabled={isTimeUp || timeUpTriggeredRef.current}
            >
              Answer
            </Button>
          )}
        </Box>
      )}

      {showPopup && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.6)",
            zIndex: 99999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <QuestionPopup
            question={questions[currentQuestion]}
            currentQuestion={currentQuestion}
            isRecording={isRecording}
            stream={stream}
            audioStream={audioStream}
            startRecording={startRecording}
            transcript={questionTranscript}
            setTranscript={setQuestionTranscript}
            handleSave={handleSave}
            onClose={() => setShowPopup(false)}
            onSaveStart={() => {
              setSavingPopupMessage("Saving your response...");
              setShowSavingPopup(true);
            }}
            onSaveEnd={() => setShowSavingPopup(false)}
          />
        </div>
      )}

      {showSavingPopup && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 100000,
          }}
        >
          <Box
            sx={{
              background: "#fff",
              padding: 4,
              borderRadius: 2,
              minWidth: 280,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Box
              sx={{
                width: 40,
                height: 40,
                border: "4px solid #e2e8f0",
                borderTop: "4px solid #f79033",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
              }}
            />
            <Typography sx={{ fontSize: 15, fontWeight: 600 }}>
              Please wait
            </Typography>
            <Typography sx={{ fontSize: 13, color: "#666" }}>
              {savingPopupMessage}
            </Typography>
          </Box>
        </Box>
      )}


      {/* {violationOpen && (
  <VivaViolationDialog
    message={violationMessage}
    count={violationCount}
    max={3}
    onContinue={() => {
      setViolationOpen(false);
      document.documentElement.requestFullscreen().catch(() => {});
    }}
  />
)} */}

      {violationOpen && violationCount < MAX_VIOLATIONS && (
        <VivaViolationDialog
          message={violationMessage}
          count={violationCount}
          max={3}
          onContinue={() => {
            setViolationOpen(false);
            document.documentElement.requestFullscreen().catch(() => { });
          }}
        />
      )}




      {/* Submit Confirmation Dialog */}
      <SubmitVivaDialog
        open={submitDialog.open}
        isAuto={submitDialog.isAuto}
        autoReason={submitDialog.autoReason}
        onClose={() => setSubmitDialog({ open: false, isAuto: false, autoReason: null })}
        isSubmitting={isSubmitting}
        onConfirm={handleDialogConfirm}
        questions={questions}
        questionStatus={questionStatus}
      />

      {showSuccess && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.6)",
            zIndex: 99999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <SubmitSuccessPopup onClose={handlePopupClose} autoClose={handlePopupClose} />
        </div>
      )}

      {/* {!showSuccess && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <Button className="submit-final-button" onClick={handleFinalSubmit}>
            Submit
          </Button>
        </Box>
      )} */}
      {!showSuccess && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <Button
            className="submit-final-button"
            variant="contained"
            color="error"
            size="large"
            // onClick={() => setShowSubmitDialog(true)}
            onClick={() => {
              setSubmitDialog({
                open: true,
                isAuto: false,
                autoReason: null,
              });
            }}
          >
            Submit
          </Button>
        </Box>
      )}
    </Box>
  );
};
